import React, { useState } from 'react';

import './YoureNotADesigner.scss';

export default function Ad() {
  const [showMessage, setShowMessage] = useState(true);

  function handleClick() {
    setShowMessage(false);
  }

  if (!showMessage) {return null;}

  return (
    <div className="display-message">
      <span className='close-display-message' onClick={handleClick}>X</span>
      <div className="display-message-content">
        <h3>Not a designer? Need a new brand?</h3>
        <p>
          A new Brand Blueprint within 72 hours. Typefaces, font-pairings, color palette, swatches, and examples. 
        </p>
        <a 
          href="https://yourenotadesigner.com?utm_source=persona&utm_medium=ad&utm_campaign=persona"
          target="_blank"
          rel="noopener noreferrer"
          className='display-message-link'
        >
          Get started today
        </a>
      </div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./client/components/YoureNotADesigner.jsx